'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = require('../actions');

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentTask = function currentTask() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'SET_CONTENT':
      return _extends({}, state, {
        content: action.file
      });
    case 'SET_STYLE':
      return _extends({}, state, {
        style: action.file
      });
    case 'SET_ALPHA':
      return _extends({}, state, {
        alpha: action.alpha
      });
    case 'CREATE_TASK':
      var record = {
        content_file_id: state.content.id,
        style_file_id: state.style.id,
        alpha: state.alpha || '0.001',
        tool: 'nsatf',
        completed: false
      };
      _client2.default.task.create(record).then(function (task) {
        task.content_file = state.content;
        task.style_file = state.file;
        action.cb && action.cb(task);
      });
      return state;
    default:
      return state;
  }
};

exports.default = currentTask;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/currentTask.js
// module id = 115
// module chunks = 0